import TripJustification from './trip-justification-component';

//import './trip-ucl-terms.scss';

const MODULE_NAME = 'app.trip.justification';
const module = angular.module(MODULE_NAME, [])
    .directive(TripJustification.DIRECTIVE_NAME, TripJustification);

export {module, MODULE_NAME as default};




// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-justification/trip-justification-module.js